import React from "react";
import PageTemplate from "./../ui/page_template";

export const Page404 = ({location}) =>
    <PageTemplate>
        <section className="page404">
            <h2>Resource not found at `{location.pathname}`</h2>
        </section>
    </PageTemplate>;

export default Page404;